<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"

    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>业务时间:</label>
            <timeStampDatePicker  type='month' v-model='query.month' class="item" ></timeStampDatePicker>
          </div>

           <div class="queryItem">
            <label>收款类型:</label>

         <lk-select class="item" v-model="query.type">
<lk-option   v-for="(item,i) in typelist" :key="i" :value="i">{{item}}</lk-option>
<!-- <lk-option :value="2">应收核销</lk-option> -->
         </lk-select>

         </div>

          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch(false)">查询</lk-button>
            <lk-button @click="clear" class="mr">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="report-btns-wrap btn">
          <!-- <exportAsync class="mr" v-if="handlePermission('retailReportByStoreExport')" @on-click='handleExport'></exportAsync> -->
<DownloadButton @on-click='handleExport' v-if="handlePermission('depositReceiveReportExport')" ></DownloadButton>
        </div>


        <lk-table
          border
          :columns='columns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import reportService from '@/services/report';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import DownloadButton from '../../components/download/DownloadButton.vue';
import reportMixin from '../report/reportMixin.js';

export default {
  name: 'depositReceiveReport',
  mixins: [mapState, queryMixins, reportMixin],
  components: {
    QueryFrame, DownloadButton,
  },
  data() {
    return {
      typelist: {
        1: '预收款',
        2: '应收收款',
      },
      query: {
        month: utils.getCurrentMonthTimestamp(),
        // endTime: utils.getNextMonthTimestamp(),
        storeIdList: [],
      },
      total: {},
      columns: [

        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 116,
        },
        {
          title: '收款类型',
          key: 'typeName',
          minWidth: 116,
        },
        {
          title: '初期金额',
          key: 'startFinanceAmount',
          minWidth: 116,
        },
        {
          title: '本期新增',
          key: 'newFinanceAmount',
          minWidth: 116,
        },
        {
          title: '本期冲销',
          key: 'verificationAmount',
          minWidth: 116,
        },
        {
          title: '期末金额',
          key: 'endFinanceAmount',
          minWidth: 116,
        },

      ],
      tableData: [],

    };
  },
  methods: {
    formatMonth(time) {
      console.log(time);
      const month = new Date(time).getMonth() + 1;
      const startTime = new Date(`${new Date(time).getFullYear()}-${month}-${1}`).getTime();
      const endTime = new Date(`${new Date(time).getFullYear() * 1 + (month == 12 ? 1 : 0)}-${month !== 12 ? month + 1 : 1}-${1}`).getTime() - 24 * 3600 * 1000;
      return {
        startTime, endTime,
      };
    },
    handleExport() {
      // this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      // this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();
      let params = utils.deepClone(this.params);
      params = Object.assign(params, this.formatMonth(params.month));
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      delete params.page;
      delete params.size;

      reportService.downloadReceiveDeposit(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    clear() {
      this.query = {
        month: utils.getCurrentMonthTimestamp(),
        // endTime: utils.getNextMonthTimestamp(),
        storeIdList: [],
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      // this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      // this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();
      this.params = Object.assign(this.params, this.formatMonth(this.params.month));
      reportService.getReceiveDepositList(this.params).then((res) => {
        if (res.data.status === 200 && res.data.data.list) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            if (result.startTime && result.endTime) {
              result.date = `${utils.formatTime(result.startTime, 'YYYY-MM-DD')}至${utils.formatTime(result.endTime, 'YYYY-MM-DD')}`;
            } else {
              result.date = '';
            }
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
  .btn{
    margin-bottom: 12px
  }
</style>
